import { render } from "./input-text.vue?vue&type=template&id=3aead7d6"
import script from "./input-text.vue?vue&type=script&lang=js"
export * from "./input-text.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__